/* eslint-disable */

$(".js-table-info-bttn").click(function (e) {
    e.preventDefault();

    $(this).next().slideToggle();
    $(this).toggleClass("is-active");

    if ($(this).hasClass("is-active")) {
        $(this).html("Less Info");
    } else {
        $(this).html("More Info");
    }
});



// WEBPACK FOOTER //
// ./scripts/partials/half-image-half-table.js